/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Filter_AnalysisInputs */

const en_gc_resources_filter_analysis = /** @type {(inputs: Gc_Resources_Filter_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis`)
};

const zh_gc_resources_filter_analysis = /** @type {(inputs: Gc_Resources_Filter_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分析`)
};

/**
* | output |
* | --- |
* | "Analysis" |
*
* @param {Gc_Resources_Filter_AnalysisInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_filter_analysis = /** @type {((inputs?: Gc_Resources_Filter_AnalysisInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Filter_AnalysisInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_filter_analysis(inputs)
	return zh_gc_resources_filter_analysis(inputs)
});
export { gc_resources_filter_analysis as "gc.resources.filter.analysis" }